<script lang="ts">
	import type { SbColor, SbImage, SbImageFormat } from '../types';
	import Image from '../components/image.svelte';
	import Plus from '$lib/icons/plus.svelte';
	import MinusV2 from '$lib/icons/minusV2.svelte';
	import PageGrid from '../components/pageGrid.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			image?: SbImage;
			format: Extract<SbImageFormat, '1/1' | '2/3' | '3/4'>;
			title: string | ISbRichtext;
			preview_text: string;
			expandable_text: string;
			box_background_color: Extract<
				SbColor,
				'stone-4' | 'green-5' | 'orange-6' | 'purple-6' | 'teal-5' | 'yellow-5'
			>;
			desktop_align: 'left' | 'right';
		}>['content'];
	}

	let { content }: Props = $props();

	let textExpanded = $state(false);

	function toggleShow() {
		textExpanded = !textExpanded;
	}
</script>

<section use:editable={content} class="my-4">
	<PageGrid>
		<div
			class="relative col-span-full aspect-{content.format} overflow-hidden rounded-2xl lg:aspect-video"
		>
			{#if content.image?.filename}
				<Image
					class="h-full w-full object-cover"
					src={content.image.filename ?? ''}
					alt={content.image.alt ?? ''}
					title={content.image.title ?? ''}
					width={780}
					sizes={{ 1024: { width: 1580 } }}
				/>
			{/if}
			<div
				class="bg-{content.box_background_color} scrollbar-hide absolute inset-x-4 bottom-4 max-h-[calc(100%-32px)] overflow-scroll rounded-xl px-4 pb-4 text-brown-2 lg:w-[40%] lg:px-6 lg:pb-6"
				class:ml-auto={content.desktop_align === 'right'}
			>
				<div
					class="sticky left-0 top-0 h-4 w-full lg:h-6"
					style="background: linear-gradient(180deg, #FEFCF5 0%, rgba(254, 252, 245, 0.00) 100%);"
				></div>
				<h1 class="text-[24px]/[110%] font-semibold lg:text-[32px]">
					<SbRichtext text={content.title} />
				</h1>
				<div class="mt-4 text-[14px]/[140%] lg:text-[18px]">
					<p>
						{content.preview_text}
						{#if textExpanded}
							<span>{content.expandable_text}</span>
						{/if}
					</p>

					{#if content.expandable_text}
						<button onclick={toggleShow} class="mt-4 flex items-center gap-x-1">
							{#if !textExpanded}
								Show more <Plus class="h-3 w-3 lg:h-4 lg:w-4" />
							{:else}
								Show less <MinusV2 class="h-3 w-3 lg:h-4 lg:w-4" />
							{/if}
						</button>
					{/if}
				</div>
			</div>
		</div>
	</PageGrid>
</section>
